/**
 * «Esa caja no tiene esa plata.»
 *
 * Avisa, no bloquea: hay cajas que todavia no tienen su saldo inicial cargado,
 * y frenar el pago por eso obligaria a inventar un ingreso. Lo usan los dos
 * lugares desde donde se le paga a un proveedor: el dialogo de la ficha y el
 * «ya esta paga» de una compra.
 */
import { Aviso } from "@/components/ui/aviso";
import { Importe } from "@/components/money";
import type { Caja } from "@/lib/tipos";

import { cajasEnNegativo } from "./logica";

export function AvisoCajasEnNegativo({
  pagos,
  cajas,
}: {
  pagos: ReadonlyArray<{ cuenta_id: number; importe: number | null }>;
  cajas: ReadonlyArray<Pick<Caja, "id" | "nombre" | "moneda" | "saldo">>;
}): JSX.Element | null {
  const negativas = cajasEnNegativo(pagos, cajas);
  if (negativas.length === 0) return null;
  return (
    <Aviso tono="warning" compacto>
      {negativas.map((c) => (
        <span key={c.nombre} className="block">
          {c.nombre} tiene <Importe monto={c.saldo} moneda={c.moneda} tamano="sm" codigo={false} />{" "}
          y con este pago queda en{" "}
          <Importe monto={c.queda} moneda={c.moneda} tamano="sm" codigo={false} />.
        </span>
      ))}
      <span className="block">
        Se registra igual. Si la plata salió de otro lado, elegí esa caja.
      </span>
    </Aviso>
  );
}
